<!--
 * @Author: ZS
 * @Date: 2020-06-09 16:36:14
 * @LastEditors: ZS
 * @LastEditTime: 2020-07-07 20:30:19
 * @Description: file content
-->
<template>
  <div class="topNav">
    <div class="sub-nav-list mainWidth">
      <ul class="clearfix">
        <li v-for="(item,index) in navData" :key="index" @click="routerLink(index, item.path)"
          :class=" navIndex == index ? 'sub-nav-select' : ''"><a href="javascript:;">{{item.title}}</a></li>
      </ul>
      <div class="protalindex" @click="goProtal()">门户首页</div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        navData: [{
            title: "首页",
            path: "/"
          },
          {
            title: "检索中心",
            path: "/search"
          },
          {
            title: "个人中心",
            path: "/user"
          },
          {
            title: "使用指南",
            path: "/userGuide"
          }
        ],
        navIndex: this.index,
      }
    },
    props: {
      index: Number
    },
    methods: {
      routerLink(index, path) {
        // 点击哪个路由就赋值给自定义的下下标
        this.navIndex = index;
        // 路由跳转
        // this.$router.push(path);
        this.$router.push({
          path: path,
        })
      },
      checkRouterLocal(path) {
        // 查找当前路由下标高亮
        this.navIndex = this.nav.findIndex(item => item.path === path);
      },
      goProtal() {
        window.open('http://campus.zzuli.edu.cn/portal-pc/pc/qy/index.html')
      }
    }
  }

</script>

<style scoped>
  .sub-nav-list {
    position: relative;
  }

  .protalindex {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 113px;
    height: 33px;
    line-height: 32px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    border: 1px solid rgba(255, 255, 255, .46);
    border-radius: 17px;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/TopNav.vue